import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSparkleCentral: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sparkle-central, star, magic, ai"><path d="M12.4844 2.75L14.7998 8.76953L14.9199 9.08008L15.2305 9.2002L21.25 11.5146V12.4844L15.2305 14.7998L14.9199 14.9199L14.7998 15.2305L12.4844 21.25H11.5156L9.2002 15.2305L9.08008 14.9199L8.76953 14.7998L2.75 12.4844V11.5146L8.76953 9.2002L9.08008 9.08008L9.2002 8.76953L11.5156 2.75H12.4844Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconSparkleCentral;
